import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../redux/store';
import { PrizeWinDisplay } from './prizeWinDisplay';
export const PrizeWinContainer = () => {
    const myPlayerId = useAppSelector((state) => state.selfData.id);
    const prizeWin = useAppSelector((state) => {
        switch (state.scene.roomSceneType) {
            case 'lobby': {
                return state.lobby.prizeWin;
            }
            case 'mttStaging': {
                return state.mttStaging.prizeWin;
            }
            case 'poker': {
                return state.poker.prizeWin;
            }
        }
    }, shallowEqual);
    if (!prizeWin) {
        return null;
    }
    const { winnerId, messageToOthers, messageToWinner, prizeDescription, durationMs } = prizeWin;
    const message = myPlayerId === winnerId ? messageToWinner : messageToOthers;
    return _jsx(PrizeWinDisplay, { message: message, prizeDescription: prizeDescription, durationMs: durationMs });
};
